import React from 'react';
import { Helmet } from 'react-helmet';
import { JSONLDSchema } from './types';

export interface Props {
  data: JSONLDSchema;
}

export const StructuredData = ({ data }: Props): JSX.Element => {
  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(data)}
      </script>
    </Helmet>
  );
};

export default StructuredData;
